import React from "react";

const options = [
    "EmbedSocial",
    "Curator",
    "Flockler",
    "Elfsight",
    "Sociablekit",
    "Prefer something else? Let us know your enchanting choice below!"
]

const Alternative = ({ setAlternativeValue, alternativeValue, setError, error }) => {
    const { feedbackName, feedbackContent, otherValue } = alternativeValue;
    return (
        <div className="p-md-10 p-5 bg-gray rounded">
            <p>We appreciate your feedback. May we ask which alternative you found more suitable? Your insights helps us improve!</p>
            <div className="alternative-form">
                <form>
                    <div className="form-group">
                        <ul className="options-list ms-3 mt-5">
                            {options.map(item => <li key={item}>
                                <div className="radio d-inline-flex" >
                                    <input type="radio" name="technical" checked={feedbackName == item} onChange={() => {
                                        setAlternativeValue(prevState => ({ ...prevState, feedbackName: item }));
                                        setError(false);
                                    }} />
                                    <label className="radio-label">{item}</label>
                                </div>
                            </li>)}
                            {(feedbackName.length == 0 && error) && <span id="feedsfield2error" className="errorMessage required">Please select an option</span>}
                        </ul>
                        {feedbackName == 'Prefer something else? Let us know your enchanting choice below!' ? <input type="text" className="form-control" placeholder="Enter Alternative Name" value={otherValue} onChange={(e) => {
                            setAlternativeValue(prevState => ({ ...prevState, otherValue: e.target.value }));
                            setError(false);
                        }} /> : null}
                        {(feedbackName == 'Prefer something else? Let us know your enchanting choice below!' && error && otherValue.length == 0) ? <span id="feedsfield2error" className="errorMessage required">This field is required</span> : null}
                    </div>
                    <div className="form-group">
                        <textarea className="form-control" placeholder="Enter your feedback" rows="6" value={feedbackContent} onChange={(e) => {
                            setAlternativeValue(prevState => ({ ...prevState, feedbackContent: e.target.value }));
                            setError(false);
                        }} />
                        {(error && feedbackContent.length == 0) ? <span id="feedsfield2error" className="errorMessage required">This field is required</span> : null}
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Alternative;